import { render, staticRenderFns } from "./changeAdmin.vue?vue&type=template&id=1a7d0a08&scoped=true"
import script from "./changeAdmin.vue?vue&type=script&lang=js"
export * from "./changeAdmin.vue?vue&type=script&lang=js"
import style0 from "./changeAdmin.vue?vue&type=style&index=0&id=1a7d0a08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7d0a08",
  null
  
)

export default component.exports